

exports.__esModule = true;
exports.$xoUpdateCardPageComponent = undefined;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _index = require('xo-models/src/checkout/index');

require('xo-page-components/src/value-props/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-validation/dist/directive');

require('xo-wallet-components/src/add-card/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoUpdateCardPageComponent = exports.$xoUpdateCardPageComponent = _squid.$Component.extend('$xoUpdateCardPageComponent', {

    tag: 'xo-update-card-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {
        // eslint-disable-line no-shadow
        $scope.callbacks = {
            finish: function finish() {
                _uiRouter.$state.go('checkout.review');
            }
        };
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;

        var models = {};

        function setErrorMessage(contentKey, msgType) {
            $scope.message = {
                msgs: [(0, _squid.$renderContent)(contentKey)],
                type: msgType
            };
        }

        (0, _squid.$populate)(models, {
            checkoutSession: _index.$CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop,
                    NEED_DEBIT_CARD: angular.noop,
                    EXPIRED_DEBIT_CARD: angular.noop
                }
            }),
            checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
            checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token).retrieve()
        }).then(function () {

            if (models.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD') {
                setErrorMessage('creditcard.errorUnconfirmedCard');
            } else if (_squid.$locale.country === 'IN' && models.checkoutCart.isBilling() && models.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN') {
                setErrorMessage('creditcard.errorBAExpiredCard', _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD' ? 'error' : 'info');
            } else {
                setErrorMessage('creditcard.errorExpiredCard', _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD' ? 'error' : 'info');
            }
        });
    }]
});

angular.value("$xoUpdateCardPageComponent", $xoUpdateCardPageComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$populate;

_squid.$renderContent;

_uiRouter.$state;

_uiRouter.$stateParams;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutSessionModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-update-card/directive.js
// module id = ./pages/xo-update-card/directive.js
// module chunks = 0